import DeliveryMethodDetail from './VoucherGroupDetail';

export default DeliveryMethodDetail;



// WEBPACK FOOTER //
// ./src/scenes/VoucherGroups/VoucherGroupDetail/index.ts